import { Component } from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular";

@Component({
    selector: "value-edit-button-cell",
    template: `
        {{label}}
        @if (buttonVisible) {
          <button mat-icon-button (click)="buttonClicked()" style="width: 25px; height: 25px; line-height: 15px">
            <mat-icon>edit</mat-icon>
          </button>
        }
        `,
    styles: [
        `
            ::ng-deep
            .mat-checkbox-layout {
                /* horizontally align the checkbox */
                width: 100%;
                display: inline-block !important;
                text-align: center;
                margin-top: -4px; /* to offset the cells internal padding - could be done in cells CSS instead*/

                /* vertically align the checkbox when not using the ag-material theme - should be the same as the 
                rowHeight - cell padding
                   (you can of course alter the cell padding via CSS instead if you'd prefer)
                line-height: 42px;
                 */
            }
        `
    ],
    standalone: false
})
export class ValueEditButtonComponent implements ICellRendererAngularComp {
    private params: any;

    label: string = '';
    buttonVisible: boolean = false;
    id: string;

    agInit(params: any): void {
        this.params = params;

        if(this.params.value != null){
            this.label = this.params.value?.name;
            this.id = this.params.value?.id;
            this.buttonVisible = true;
        }
        //this.checked = this.params.value === "On";
    }

    buttonClicked() {
        this.params.edit.call(this.params.that, this.id);
    }

    refresh(params: any): boolean {
        return false;
    }
}